import 'intersection-observer';
import { registerSW } from 'virtual:pwa-register';
import './App';

// Register Service Worker for PWA
registerSW({
  immediate: true,
  onOfflineReady() {
    // eslint-disable-next-line no-console
    console.log('App ready to work offline');
  },
});

// Add module hot replacement for development
if (import.meta.hot) {
  import.meta.hot.accept();
}
